module.exports = __webpack_public_path__ + "img/enabled_selected.44ed08ee.svg";